import { render } from "./ImportEquipos.vue?vue&type=template&id=2cb83c0d"
import script from "./ImportEquipos.vue?vue&type=script&lang=js"
export * from "./ImportEquipos.vue?vue&type=script&lang=js"

import "./ImportEquipos.vue?vue&type=style&index=0&id=2cb83c0d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__